import useSWR from "swr"
import { useCsrfToken } from "./useCsrfToken"
import { fetchGraphqlQuery } from "common/lib/fetchGraphqlQuery"

export const useGraphqlQuery = <T>(
  query: string | null,
  variables?: Record<string, string | number | boolean>,
) => {
  const { token } = useCsrfToken()
  const shouldFetch = token && query
  const cacheKey = [query, token, variables]
  const {
    data,
    error,
    isValidating: loading,
  } = useSWR<T>(
    shouldFetch ? cacheKey : null,
    ([query, token, variables]) =>
      fetchGraphqlQuery(
        query,
        {
          "X-CSRF-Token": token,
        },
        variables,
      ),
    {},
  )

  return { loading, error, data }
}
